import React, { useEffect, useState } from "react";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import { LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import Pagamento from "../Pagamento/Pagamento";
import InputBlur from "../../components/InputBlur";
import SelectPesq from "../../components/Selects/SelectPesq";
import TabelaPadrao from "../../components/TabelaPadrao";
import roundCustom, { floorCustom } from "../../Utils/RoundCustom";
import toLocale from "../../Utils/ToLocaleString";
import { EditarLoteIcon, useProdutoLote } from "../../Contexts/ProdutoLoteContext";

export default function VendaDevolucaoModal({ produtos = [], pagamentos = [], pagamentosOriginais, visible, onOk, onCancel, cliente, loading, showCliente }) {
    const [produtosDev, setProdutosDev] = useState([]);
    const [pagamentosDev, setPagamentosDev] = useState([]);
    const [totais, setTotais] = useState({});
    const [pesqCliente, setPesqCliente] = useState([]);

    const { handleProdutoLote } = useProdutoLote();

    useEffect(() => {
        if (visible) {
            setProdutosDev(produtos.map(x => ({ ...x, qtdOriginal: x.qtd, qtdDev: x.qtdDev || 0, valorTotalDev: x.valorTotalDev || 0, descontoDev: x.descontoDev || 0, valorFreteDev: x.valorFreteDev || 0, acrescimoDev: x.acrescimoDev || 0 })));
            const valorDev = produtos.reduce((a, b) => a + (b.valorTotalDev || 0), 0);
            const descontoDev = produtos.reduce((a, b) => a + (b.descontoDev || 0), 0);
            setTotais({ total: 0, liquido: valorDev, bruto: valorDev, desconto: descontoDev, troco: 0, acrescimo: 0, valorFrete: 0 });
            setPagamentosDev(pagamentos || []);

            if (!!cliente)
                setPesqCliente([cliente]);
        }
        else {
            setProdutosDev([]);
            setPagamentosDev([]);
            setTotais({});
        }

    }, [visible]);

    useEffect(() => {
        var total = roundCustom(pagamentosDev.reduce((a, b) => a + b.recebido, 0));
        setTotais({ ...totais, total, troco: total <= totais.liquido ? 0 : roundCustom(-(totais.liquido - total)) });

    }, [pagamentosDev]);

    const columns = [
        {
            Header: "Código",
            accessor: "codigo",
            Footer: " "
        },
        {
            Header: "Descrição",
            accessor: "descricao",
            Cell: props => <span>
                {props.row.original.descricao}
                <EditarLoteIcon onClick={() => handleProdutoLote(props.row.original, lotes => {
                    const aux = [...produtosDev];
                    aux[props.row.index].lotes = lotes;
                    setProdutosDev(aux);
                }, props.fetch)} qtd={props.row.original.qtdDev} lotes={props.row.original.lotes} isLote={props.row.original.isLote} />
            </span>
        },
        {
            Header: "Qtd.",
            accessor: "qtd",
            tipo: "dec"
        },
        {
            Header: "Valor Un.",
            accessor: "valorUnRateado",
            tipo: "dec"
        },
        {
            Header: "Qtd. já devolvida",
            accessor: "qtdDevolvida",
            Cell: props => <span>{!!props.row.original.qtdDevolvida ? props.row.original.qtdDevolvida : 0}</span>,
            tipo: "dec",
        },
        {
            Header: "Qtd. devolvida",
            accessor: "qtdDev",
            tipo: "right",
            Cell: props => <InputBlur
                type="number"
                style={{ maxWidth: 100 }}
                value={props.row.original.qtdDev}
                precision={4}
                min={0}
                max={roundCustom(props.row.original.qtd - (props.row.original?.qtdDevolvida || 0), 5)}
                onChange={v => {
                    const aux = [...produtosDev];
                    const item = aux[props.row.index];
                    var qtd = v;

                    if (qtd > item.qtd)
                        qtd = item.qtd;

                    const isQtdLimite = qtd == (item.qtd + item.qtdDevolvida);
                    item.qtdDev = qtd;

                    item.descontoDev = isQtdLimite ? floorCustom(item.desconto - (item.descontoRateado * item.qtdDevolvida)) : floorCustom(item.descontoRateado * qtd);
                    item.acrescimoDev = isQtdLimite ? floorCustom(item.acrescimo - (item.acrescimoRateado * item.qtdDevolvida)) : floorCustom(item.acrescimoRateado * qtd);
                    item.valorFreteDev = isQtdLimite ? floorCustom(item.valorFrete - (item.valorFreteRateado * item.qtdDevolvida)) : floorCustom(item.valorFreteRateado * qtd);
                    item.valorTotalDev = (isQtdLimite ? floorCustom(item.valorTotal - (item.valorUnRateado * item.qtdDevolvida)) : floorCustom(item.valorUnRateado * qtd));

                    setProdutosDev(aux);

                    const valorDev = roundCustom(aux.reduce((a, b) => a + (b.valorTotalDev || 0), 0));
                    const descontoDev = roundCustom(aux.reduce((a, b) => a + (b.descontoDev || 0), 0));
                    const acrescimoDev = roundCustom(aux.reduce((a, b) => a + (b.acrescimoDev || 0), 0));
                    const valorFreteDev = roundCustom(aux.reduce((a, b) => a + (b.valorFreteDev || 0), 0));
                    setTotais({ total: 0, liquido: valorDev, bruto: valorDev + descontoDev - acrescimoDev - valorFreteDev, desconto: descontoDev, acrescimo: acrescimoDev, valorFrete: valorFreteDev, troco: 0 });
                    let modalidadePadrao = {};

                    if (produtos.at(-1).id == props.row.original.id && pagamentosOriginais?.length == 1)
                        modalidadePadrao = pagamentosOriginais.find(x => x.tipo != "vale" && x.tipo != "crediario");

                    setPagamentosDev([{ ...modalidadePadrao, recebido: valorDev }]);
                }}
            />
        },
        {
            Header: "Desconto devolvido",
            accessor: "descontoDev",
            tipo: "rs",
            Somar: true
        },
        {
            Header: "Acréscimo devolvido",
            accessor: "acrescimoDev",
            tipo: "rs",
            Somar: true
        },
        {
            Header: "Frete devolvido",
            accessor: "valorFreteDev",
            tipo: "rs",
            Somar: true
        },
        {
            Header: "Valor total devolvido",
            accessor: "valorTotalDev",
            tipo: "rs",
            Somar: true
        },
    ];

    return <ModalPadrao title="Devolver itens" visible={visible} closable={false} footer={<>
        <BtnGravar disabled={!!totais.liquido && pagamentosDev.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} loading={loading} onClick={() => onOk(produtosDev.map(x => ({ ...x, qtd: x.qtdOriginal, qtdOriginal: undefined })), pagamentosDev.filter(x => !!x.modalidadeId), totais, pesqCliente)} txt="Confirmar" />
        <BtnSair onClick={onCancel} disabled={loading} />
    </>} width={1200}>
        <LoadingContainerPadrao loading={loading} style={{ minHeight: 300 }}>
            {!!showCliente && <div style={{ width: "80%", margin: "auto", marginBottom: 25 }}>
                <SelectPesq noMargin placeholder="Selecione o cliente" title="Cliente" modelo="cliente" value={pesqCliente} onChange={setPesqCliente} showAdd showEdit />
            </div>}
            <TabelaPadrao columns={columns} data={produtosDev} />
            {!!totais.liquido && <Pagamento totais={totais} pg={pagamentosDev} setPg={setPagamentosDev} clienteId={(pesqCliente || [])[0]?.key} extra={<>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                    <LabelPadrao noMargin><b>Acréscimo:</b></LabelPadrao>
                    <span style={{ fontSize: "1.25em", color: "#999" }}>{toLocale(totais.acrescimo)}</span>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(0, 0, 0, 0.06)" }}>
                    <LabelPadrao noMargin><b>Frete:</b></LabelPadrao>
                    <span style={{ fontSize: "1.25em", color: "#999" }}>{toLocale(totais.valorFrete)}</span>
                </div>
            </>} tipo="devolucao" />}
        </LoadingContainerPadrao>
    </ModalPadrao>;
}